import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthenticatedHeader from '../components/AuthenticatedHeader';
import AccountMenu from '../components/AccountMenu';
import { RequireAuth } from '../contexts/RequireAuth';

const AccountLayout = () => (
  <RequireAuth>
    <div className="container">
      <AuthenticatedHeader />
      <div className="layout">
        <AccountMenu />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  </RequireAuth>
);

export default AccountLayout;
